import streamMessagesReducer from 'utils/messages/StreamMessage';
import { StreamMessageElement } from 'communication/types/StreamElement';
import { LiquiditySummaryElement } from 'widgets/liquiditySummary/api/LiquiditySummaryElement';
import { LiquiditySummaryStreamElementType } from 'widgets/liquiditySummary/api/LiquiditySummaryStreamElementType';
import {
    initialLiquiditySummaryDataState,
    initialLiquiditySummaryStreamState,
    LiquidityStreamState,
    LiquiditySummaryDataState,
} from './LiquiditySummaryDataState';
import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';
import {
    createLiquidityRequestUid,
    toLiquidityRequestUid,
} from 'widgets/liquiditySummary/store/data/LiquiditySummaryStreamRequest';

export function processLiquiditySummaryStreamElement(
    element: LiquiditySummaryElement,
    nextState: LiquidityStreamState
) {
    const nextDataState: LiquiditySummaryDataState = nextState.data ?? {
        ...initialLiquiditySummaryDataState,
    };

    streamMessagesReducer(element as StreamMessageElement, nextState);

    switch (element._c) {
        case LiquiditySummaryStreamElementType.Info: {
            nextDataState.previousClosePrice = element.pncD;
            nextDataState.averageDailyVolume = element.adv;
            nextDataState.oldOpenVol = element.openVol;
            nextDataState.oldCloseVol = element.closeVol;
            nextDataState.histOpenVol = element.histOpenVol;
            nextDataState.histCloseVol = element.histCloseVol;
            break;
        }
        case LiquiditySummaryStreamElementType.Volume: {
            nextDataState.volume = element.v;
            break;
        }
        case LiquiditySummaryStreamElementType.PredRemVol: {
            nextDataState.oldPredictedRemainingVolume = element.v;
            nextDataState.rtaPredRemVol = element.rtaPredRemVol;
            nextDataState.rtaPredTotVol = element.rtaPredTotVol;
            nextDataState.predCloseVol = element.predCloseVol;
            nextDataState.actualVsHistPct = element.actualVsHistPct;
            nextDataState.volumeScale = element.volumeScale;
            break;
        }
        case LiquiditySummaryStreamElementType.PredTradVol: {
            nextDataState.predictedTradedVolume = element.v;
            break;
        }
        case LiquiditySummaryStreamElementType.PredCloseAuctionVol: {
            nextDataState.oldPredictedClosingAuctionVolume = element.v;
            nextDataState.predictedClosingAuctionVolume =
                element.rtaPredCloseVol;
            break;
        }
    }
}

const selectLiquidityStreamedData = (state: State) =>
    selectStreamedDataState(state).liquidity;

const buildLiquidityStreamSlice = () =>
    buildStreamedDataStreamSlice(
        'startLiquidityStream',
        initialLiquiditySummaryStreamState,
        selectLiquidityStreamedData,
        createLiquidityRequestUid,
        toLiquidityRequestUid,
        processLiquiditySummaryStreamElement
    );

const {
    reducer: liquidityStreamedDataReducer,
    selectors: liquidityStreamedDataSelectors,
} = buildLiquidityStreamSlice();

export { liquidityStreamedDataReducer, liquidityStreamedDataSelectors };
